import React, { useState } from "react";
import "./components/Navbar.css";
import { Link, NavLink } from "react-router-dom";
const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const navLinks = [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
        { name: "Services", path: "/services" },
        { name: "AI Solutions", path: "/ai-solutions" },
        { name: "Marketing & Growth Advisory", path: "/marketing-growth-advisory" },
        { name: "Research & Insights", path: "/research-insights" },
        { name: "Innovation Studio", path: "/innovation-studio" },
        { name: "Industries", path: "/industries" },
        { name: "Contact", path: "/contact" }
    ];

    return (
        <header className="navbar">
            <div className="nav-container">

                {/* Logo */}
                <Link to="/" className="logo">
                    <div className="logo-icon">△</div>
                    <span>KARMA & DELTA LLC</span>
                </Link>

                {/* Desktop Links */}
                <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
                    {navLinks.map((link, index) => (
                        <NavLink
                            key={index}
                            to={link.path}
                            end={link.path === "/"}   // important for home
                            className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                            }
                        >
                            {link.name}
                        </NavLink>
                    ))}

                    <Link to="/contact" className="nav-cta">
                        Start a Conversation
                    </Link>
                </nav>

                {/* Mobile Toggle */}
                <div
                    className={`hamburger ${menuOpen ? "open" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

            </div>
        </header>
    );
};

export default Navbar;